var botPattern = /(adsbot|applebot|baiduspider|bingbot|crawl|facebookexternalhit|googlebot|linkedinbot|mj12bot|petalbot|pingdom|slackbot|telegrambot|twitterbot|yandex|bot|crawler|spider|headless|preview)/i;

/**
 * Checks whether the given User-Agent string belongs to a known bot or crawler.
 * @param {string} userAgent - The User-Agent string from the request header.
 * @returns {boolean} - Returns true if the User-Agent matches known bot patterns, false otherwise.
 */
function isBotRequest(userAgent) {
    return botPattern.test(userAgent);
}

module.exports = {
    isBotRequest
};
